import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { AuthFormLocation } from '@as-react/common-types';
import { getHomepageUrl } from '@as-react/common-utils';
import { Box } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Authentication } from '../components/account/authentication/Authentication';
import { useFeatureToggle } from '../hooks/useFeatureToggle';
import { useOAuth } from '../hooks/useOAuth';
import { usePageShow } from '../hooks/usePageShow';
import { authActions } from '../redux/authentication/actions/AuthActions.creators';
import { makeGetLoginError, makeGetResetPasswordState, makeGetLoginLoading, } from '../redux/authentication/selectors/AuthSelectors';
import { makeGetLoggedInState } from '../redux/session/selectors/SessionSelector';
import { getBoxPropsFromAEMPaddings } from '../util/AEMUtil';
import { mimicDelay } from '../util/GeneralUtil';
const LoginContainer = ({ paddings, redirectLink, hideTitle }) => {
    const { root, isInAuthorMode } = useAemConfig();
    const resetPasswordState = useSelector(makeGetResetPasswordState());
    const loading = useSelector(makeGetLoginLoading());
    const loginError = useSelector(makeGetLoginError());
    const loggedIn = useSelector(makeGetLoggedInState());
    const dispatch = useDispatch();
    const { authUrl } = useOAuth({ returnTo: redirectLink || getHomepageUrl(root) });
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    usePageShow();
    useEffect(() => {
        const redirectUser = () => __awaiter(void 0, void 0, void 0, function* () {
            yield mimicDelay();
            window.location.href = redirectLink || getHomepageUrl(root);
        });
        if (loggedIn) {
            redirectUser();
        }
        else if (isNewAuth) {
            window.location.href = authUrl;
        }
    }, [loggedIn]);
    const handleLoginSubmit = ({ email, password, keepSignedIn }) => {
        dispatch(authActions.login({
            username: email,
            password,
            keepSignedIn,
            reloadOnSuccess: false,
            location: AuthFormLocation.LOGIN,
        }));
    };
    const handleResetPasswordSubmit = ({ email }) => {
        dispatch(authActions.createResetCredentialsAction(email));
    };
    const handleOnAuthResetForm = () => {
        dispatch(authActions.resetError());
    };
    const resetForgotPasswordState = () => {
        (resetPasswordState.success || resetPasswordState.error) &&
            dispatch(authActions.createResetCredentialsSuccessAction(null));
    };
    if (isNewAuth) {
        return null;
    }
    return (_jsx(Box, Object.assign({}, getBoxPropsFromAEMPaddings(paddings), { children: _jsx(Authentication, { hasShadow: true, login: {
                onSubmit: handleLoginSubmit,
                errorFeedback: loginError,
                loading,
            }, forgotPassword: {
                onSubmit: handleResetPasswordSubmit,
                errorFeedback: resetPasswordState.error,
                successFeedback: resetPasswordState.success,
            }, hideTitle: hideTitle, isInAuthorMode: isInAuthorMode, onAuthResetForm: handleOnAuthResetForm, resetForgotPasswordState: resetForgotPasswordState }) })));
};
export default LoginContainer;
